'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var ItemCardClaims = require('./ItemCardClaims.js');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var style = require('../utils/style.js');
var Tag = require('./Tag.js');
var nthHookTheme = require('@narvar/nth-hook-theme');
var Drawer = require('./layout/Drawer.js');
var index = require('./Icon/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const TagContent = _ref => {
  let {
    content
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement("span", null, content, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    icon: "CheckMark",
    width: "11",
    height: "11",
    style: {
      marginLeft: '8px'
    }
  }));
};
const DrawerItemClaim = _ref2 => {
  let {
    itemDetails,
    claimDetails
  } = _ref2;
  const {
    claimsTagSelected
  } = nthHookTranslations.useTranslations();
  const {
    selecteditemNoneNone,
    buttonsPrimaryDefault
  } = nthHookTheme.useTheme();
  return /*#__PURE__*/React__default["default"].createElement(Tag["default"], {
    tagContent: /*#__PURE__*/React__default["default"].createElement(TagContent, {
      content: claimsTagSelected || ''
    }),
    anchor: {
      horizontal: 'left',
      vertical: 'top'
    },
    s: {
      ...selecteditemNoneNone,
      borderRadius: 0,
      borderBottomRightRadius: (selecteditemNoneNone === null || selecteditemNoneNone === void 0 ? void 0 : selecteditemNoneNone.borderBottomRightRadius) ?? (selecteditemNoneNone === null || selecteditemNoneNone === void 0 ? void 0 : selecteditemNoneNone.borderRadius) ?? 3,
      backgroundColor: style.getBorderColor(selecteditemNoneNone) ?? (buttonsPrimaryDefault === null || buttonsPrimaryDefault === void 0 ? void 0 : buttonsPrimaryDefault.backgroundColor)
    }
  }, /*#__PURE__*/React__default["default"].createElement(Drawer.DrawerFooterSection, null, /*#__PURE__*/React__default["default"].createElement(ItemCardClaims["default"], {
    itemDetails: itemDetails,
    claimDetails: claimDetails,
    layout: "horizontal"
  })));
};
var MobileDrawerItemDetails = nthHookTheme.withThemeProvider(nthHookTranslations.withTranslationsProvider(DrawerItemClaim, {
  translationKeys: ['claimsTagSelected']
}), {
  themeTokens: ['selecteditemNoneNone', 'buttonsPrimaryDefault']
});

exports["default"] = MobileDrawerItemDetails;
